import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './AnimationWrapper.module.scss'

export const AnimationWrapper: FunctionComponent<AnimationWrapperProps> = ({
  children,
  inverted = false,
  className,
  ...rest
}) => (
  <span
    className={classnames(
      styles.animation,
      {
        [styles.animationInverted]: inverted,
      },
      className
    )}
    {...rest}
  >
    {children}
  </span>
)

///////// IMPLEMENTATION /////////

export type AnimationWrapperProps = {
  children: ReactNode
  inverted?: boolean
  className?: string
  [key: `data-${string}`]: string | undefined
} & HTMLProps<HTMLSpanElement>
